import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from './shared.module';
import { PatientsModule } from '../features/patients/patients.module';
import { PatientDetailOverlayHostComponent } from './components/patient-detail-overlay-host/patient-detail-overlay-host.component';

@NgModule({
  declarations: [PatientDetailOverlayHostComponent],
  imports: [CommonModule, SharedModule, PatientsModule],
  exports: [PatientDetailOverlayHostComponent]
})
export class PatientDetailOverlayHostModule {}
